import Header from "./components/Header";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useData } from "./providers/ContextProvider";

export default function App() {
  const {
    state: { isLoggedIn },
  } = useData();
  const navigate = useNavigate();

  function checkLoggedInStatusAndNavigate() {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }

  useEffect(checkLoggedInStatusAndNavigate);

  return (
    <main className="main">
      <Header />
      <Outlet />
    </main>
  );
}
